"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simcard5G = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Simcard5G = function Simcard5G(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 160 130",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.8",
    d: "M58.3795 44.0216C69.0557 24.5531 84.9593 16.6757 98.2056 32.2799C109.896 46.0509 134.111 51.8925 134.111 63.5764C134.111 75.2604 130.702 79.8298 117.271 82.2634C103.839 84.697 110.383 112.161 91.0967 114.595C71.8108 117.029 73.1553 107.808 49.0809 105.208C13.4563 101.361 20.9671 70.2527 32.2057 65.9238C42.2519 62.0541 47.7033 63.4901 58.3795 44.0216Z",
    fill: "#E7F5FC"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.0001 100.222H100C101.657 100.222 103 98.8789 103 97.222V48.5191C103 47.7175 102.679 46.9493 102.109 46.3857L91.211 35.6108C90.6494 35.0555 89.8916 34.7441 89.1018 34.7441H59.0001C57.3432 34.7441 56.0001 36.0873 56.0001 37.7441V97.222C56.0001 98.8789 57.3432 100.222 59.0001 100.222Z",
    fill: "#D0EBF9",
    stroke: "#0095E0",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "64.1869",
    y: "72",
    width: "29.6717",
    height: "21.6571",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M82.7054 80.9629C82.7054 79.306 84.0486 77.9629 85.7054 77.9629H93.8165V88.1003H85.7054C84.0486 88.1003 82.7054 86.7571 82.7054 85.1003V80.9629Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M87.3351 88.6973V91.3807H71.5943V94.0641",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.2979 85.1016C75.2979 86.7584 73.9548 88.1016 72.2979 88.1016L64.1868 88.1016L64.1868 77.9642L72.2979 77.9642C73.9548 77.9642 75.2979 79.3073 75.2979 80.9642L75.2979 85.1016Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M71.5943 77.3672L71.5943 74.6838L87.3351 74.6838L87.3351 72.0003",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "65.1869",
    y1: "82.9258",
    x2: "92.8165",
    y2: "82.9258",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "55.9444",
    cy: "58.2229",
    rx: "18.2778",
    ry: "17.8889",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.0223 57.7578L46.8426 50.5312H54.8114V52.8848H49.1571L48.8055 55.9414C49.4761 55.5833 50.189 55.4043 50.9442 55.4043C52.2983 55.4043 53.3595 55.8242 54.1278 56.6641C54.896 57.5039 55.2801 58.679 55.2801 60.1895C55.2801 61.1074 55.0848 61.931 54.6942 62.6602C54.3101 63.3828 53.7567 63.946 53.034 64.3496C52.3114 64.7467 51.4585 64.9453 50.4754 64.9453C49.6161 64.9453 48.8185 64.7728 48.0828 64.4277C47.3472 64.0762 46.7645 63.5846 46.3348 62.9531C45.9116 62.3216 45.687 61.6022 45.661 60.7949H48.4539C48.5125 61.3874 48.7176 61.8496 49.0692 62.1816C49.4272 62.5072 49.8927 62.6699 50.4657 62.6699C51.1037 62.6699 51.5952 62.4421 51.9403 61.9863C52.2853 61.5241 52.4578 60.873 52.4578 60.0332C52.4578 59.2259 52.2593 58.6074 51.8621 58.1777C51.465 57.748 50.9019 57.5332 50.1727 57.5332C49.5021 57.5332 48.9585 57.709 48.5418 58.0605L48.2684 58.3145L46.0223 57.7578ZM65.5356 63.3125C65.1137 63.8177 64.5174 64.2109 63.7465 64.4922C62.9757 64.7682 62.1215 64.9062 61.184 64.9062C60.1996 64.9062 59.3351 64.6927 58.5903 64.2656C57.8507 63.8333 57.2778 63.2083 56.8715 62.3906C56.4705 61.5729 56.2648 60.612 56.2543 59.5078V58.7344C56.2543 57.599 56.4444 56.6172 56.8246 55.7891C57.2101 54.9557 57.7621 54.3203 58.4809 53.8828C59.2049 53.4401 60.0512 53.2188 61.02 53.2188C62.3689 53.2188 63.4236 53.5417 64.184 54.1875C64.9444 54.8281 65.395 55.763 65.5356 56.9922H63.2543C63.1502 56.3411 62.9184 55.8646 62.559 55.5625C62.2049 55.2604 61.7153 55.1094 61.0903 55.1094C60.2934 55.1094 59.6866 55.4089 59.27 56.0078C58.8533 56.6068 58.6424 57.4974 58.6371 58.6797V59.4062C58.6371 60.599 58.8637 61.5 59.3168 62.1094C59.77 62.7188 60.434 63.0234 61.309 63.0234C62.1892 63.0234 62.8168 62.8359 63.1918 62.4609V60.5H61.059V58.7734H65.5356V63.3125Z",
    fill: "#0095E0"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "123",
    y: "27",
    width: "7",
    height: "7",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "33.9645",
    y: "15.5",
    width: "7",
    height: "7",
    transform: "rotate(-45 33.9645 15.5)",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "92.5352",
    width: "7",
    height: "7",
    transform: "rotate(-45 16 92.5352)",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "133",
    y: "40",
    width: "7",
    height: "7",
    rx: "3.5",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "125",
    y: "111",
    width: "7",
    height: "7",
    rx: "3.5",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }));
};
exports.Simcard5G = Simcard5G;